/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "right",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      foreignSupplier: "",
      address: "",
      country: "",
      taxRevenue1: 0,
      gtgtPercent: 0,
      gtgtCompulsoryTax: 0,
      taxRevenue2: 0,
      tndnPercent: 0,
      taxExemption: 0,
      tndnCompulsoryTax: 0,
      totalTax: 0,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        foreignSupplier: "",
        address: "",
        country: "",
        taxRevenue1: 0,
        gtgtPercent: 0,
        gtgtCompulsoryTax: 0,
        taxRevenue2: 0,
        tndnPercent: 0,
        taxExemption: 0,
        tndnCompulsoryTax: 0,
        totalTax: 0,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                rowSpan={2}
                className="toggle-button"
                style={{ textAlign: "center", minWidth: 10, fontWeight: "bold" }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200, fontWeight: "bold" }}>
                Tên nhà cung cấp nước ngoài
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200, fontWeight: "bold" }}>
                Địa chỉ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200, fontWeight: "bold" }}>
                Quốc gia
              </Td>
              <Td colSpan={3} style={{ textAlign: "center", minWidth: 200, fontWeight: "bold" }}>
                Thuế giá trị gia tăng (GTGT)
              </Td>
              <Td
                colSpan={4}
                style={{ textAlign: "center", minWidth: 200, maxWidth: 500, fontWeight: "bold" }}
              >
                Thuế thu nhập doanh nghiệp (TNDN) Corporate Income Tax (CIT)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200, fontWeight: "bold" }}>
                Tổng số thuế phải nộp vào ngân sách Nhà nước
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Doanh thu tính thuế</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                Tỷ lệ % thuế GTGT trên doanh thu
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế giá trị gia tăng phải nộp
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Doanh thu tính thuế</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                Tỷ lệ % thuế TNDN trên doanh thu
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                Số thuế được miễn giảm theo Hiệp định
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế thu nhập doanh nghiệp phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(1)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(2)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(3)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(4)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(5)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(6=4x5)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(7)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(8)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(9)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>[10=(7x8)-(9)]</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(11)=(6)+(10)</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="foreignSupplier"
                    value={item.foreignSupplier}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="address"
                    value={item.address}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "country", e.target.value)}
                  >
                    <option value="value1">Quốc gia 1</option>
                    <option value="value2">Quốc gia 2</option>
                    <option value="value3">Quốc gia 3</option>
                    <option value="value4">Quốc gia 4</option>
                    <option value="value5">Quốc gia 5</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxRevenue1"
                    value={item.taxRevenue1}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="gtgtPercent"
                    value={item.gtgtPercent}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    style={{
                      textAlign: "right",
                      background: "#ddeff3",
                      border: 0,
                    }}
                    readOnly={true}
                    id={item.id}
                    name="gtgtCompulsoryTax"
                    value={item.gtgtCompulsoryTax}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxRevenue2"
                    value={item.taxRevenue2}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="tndnPercent"
                    value={item.tndnPercent}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxExemption"
                    value={item.taxExemption}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    style={{
                      textAlign: "right",
                      background: "#ddeff3",
                      border: 0,
                    }}
                    readOnly={true}
                    id={item.id}
                    name="tndnCompulsoryTax"
                    value={item.tndnCompulsoryTax}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    style={{
                      textAlign: "right",
                      background: "#ddeff3",
                      border: 0,
                    }}
                    readOnly={true}
                    id={item.id}
                    name="totalTax"
                    value={item.totalTax}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            <tr key={1000}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  style={{
                    textAlign: "center",
                    background: "#ddeff3",
                    border: 0,
                  }}
                  value={"Tổng cộng"}
                />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                    border: 0,
                  }}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>{" "}
              <Td
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                    border: 0,
                  }}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                    border: 0,
                  }}
                  value={0}
                />
              </Td>
              <Td
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                    border: 0,
                  }}
                  value={0}
                />
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
      <Typography fontWeight="bold" fontSize={14} style={{ marginTop: 10 }}>
        Tổng số thuế GTGT và thuế TNDN phải nộp kỳ này (Viết bằng chữ):
      </Typography>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
